import { render } from "./ListGame.vue?vue&type=template&id=459fb14a"
import script from "./ListGame.vue?vue&type=script&lang=js"
export * from "./ListGame.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__